import { componentProvider } from 'js-component-framework/es';
import ToggleButton from '@/js/ToggleButton';

// Component styles.
import './title-formats.scss';

/**
 * TitleFormats component.
 */
class TitleFormats {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Set up the dropdown toggle.
   */
  init() {
    this.toggleButton = new ToggleButton(this.element, this.options);
  }
}

const titleFormatsConfig = {
  name: 'title-formats-toggle-button',
  component: TitleFormats,
  options: {},
};

componentProvider(titleFormatsConfig);
